<script>
import { mapState } from 'vuex';

export default {
    name: "about",
    data() {
        return {
            name: '',
            phone: '',
            email: '',
            address: '',
            subject: '',
            content: '',
        };
    },
    computed: {
        ...mapState(['galleryAbout']),
    },
    components: {
        
    },
    mounted() { 
        this.$store.dispatch('getGalleryAbout');
    },
     destroyed() {},
    watch: {},
    methods: {
        submit() {
            if(this.isLoading){
                return false;
            }
            if(this.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.name.focus();
                this.$showToast({ text: '请输入姓名' }); //
                // this.$showToast({ text: 'Please enter name' }); //请输入姓名
                return false;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' }); //请输入邮箱
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: '请输入邮箱' }); //请输入邮箱
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: '邮箱格式有误' }); //邮箱格式有误
                return false;
            }
            if(this.address.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.address.focus();
                this.$showToast({ text: '请输入地址' }); //请输入邮箱
                return false;
            }
            if(this.subject.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.subject.focus();
                this.$showToast({ text: '请输入主题' }); //请输入邮箱
                return false;
            }
            if(this.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.content.focus();
                this.$showToast({ text: '请输入留言' }); //请输入邮箱
                return false;
            }
            this.isLoading = true;
            this.$showLoading();
            this.$store.dispatch('submitMessage', {
                type: '联系我们',
                name: this.name,
                email: this.email,
                phone: this.phone,
                address: this.address,
                message: this.content,
                theme: this.subject,
            }).then((result) => {
                this.isLoading = false;
                this.$hideLoading();
                if (result.code == 100) { 
                    this.$showToast({ text: '上传成功' });
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.address = '';
                    this.content = '';
                    this.subject = '';
                } else {
                    this.$showToast({ text: '上传失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '上传失败' });
            });
        }
    },
};
</script>

<template>
    <div class="about layout_body">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg" :style="`background-image: url(${galleryAbout.banner});`"></div>
        </div>
        <!--  -->
        <div class="layout_main">
            <div class="layout_content">
                <p class="breadcrumb only_pc"><router-link to="/gallery">A+ Studio Gallery</router-link> / 关于画廊</p>
                <div class="content flex">
                    <div class="text">
                        <p class="title">{{ galleryAbout.name }}</p>
                        <p class="desc" v-html="$textToHtml(galleryAbout.desc)"></p>
                    </div>
                    <div class="cover only_pc">
                        <div class="layout_bg" :style="`background-image: url(${galleryAbout.image});`"></div>
                    </div>
                </div>
                <div class="content flex">
                    <div class="info">
                        <div class="title">画廊相关信息</div>
                        <template v-if="galleryAbout.address">
                            <p class="name">地址：</p>
                            <div class="desc" v-html="$textToHtml(galleryAbout.address)"></div>
                        </template>
                        <template v-if="galleryAbout.open_time">
                            <p class="name">开放时间：</p>
                            <div class="desc" v-html="$textToHtml(galleryAbout.open_time)"></div>
                        </template>
                        <template v-if="galleryAbout.phone || galleryAbout.email">
                            <p class="name">联系我们：</p>
                            <div class="desc">
                                <p>T：<a :href="`tel:+${galleryAbout.phone}`">{{ galleryAbout.phone }}</a></p>
                                <p>E：<a :href="`mailto:${galleryAbout.email}`">{{ galleryAbout.email }}</a></p>
                            </div>
                        </template>
                    </div>
                    <div class="form">
                        <div class="title">留言</div>
                        <div class="input_group">
                            <input type="text" ref="name" v-model="name" placeholder="姓名"/>
                            <input type="tel" ref="phone" v-model="phone" placeholder="手机号"/>
                        </div>
                        <div class="input_group">
                            <input type="text" ref="email" v-model="email" placeholder="E-mail"/>
                            <input type="text" ref="address" v-model="address" placeholder="地址"/>
                        </div>
                        <div class="input_group">
                            <input type="text" ref="subject" v-model="subject" placeholder="主题"/>
                        </div>
                        <div class="input_group">
                            <textarea ref="content" v-model="content" placeholder="留言"></textarea>
                        </div>
                        <div class="input_group justify_end">
                            <div class="btn layout_flex_center" @click="submit">提交</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.content{
    gap: .6rem;
    margin-bottom: 1rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        margin-bottom: 0;
        padding: .3rem 0;
    }
    &:last-child{
        margin-bottom: 0;
    }
    .title{
        font-size: .25rem;
        font-weight: bold;
        margin-bottom: .2rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            text-align: center;
            margin-bottom: .3rem;
        }
    }
    .desc{
        font-size: .2rem;
        line-height: 2;
        flex: 1;
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
            color: #666;
        }
    }
    .cover{
        width: 4.4rem;
        height: 2.8rem;
        // border: 1px solid #000;
        @media only screen and (max-width: 750px) {
            width: 7.5rem;
            height: 6.3rem;
            margin: 0 -.3rem;
        }
    }
    .info{
        font-size: .18rem;
        line-height: 1.8;
        flex: 1;
        .title{
            // margin-bottom: .2rem;
        }
        .name{
            font-size: .2rem;
            font-weight: bold;
        }
        .desc{
            margin-bottom: .6rem;
            &:last-child{
                margin-bottom: 0;
            }
        }
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
            text-align: center;
            .name{
                font-size: .28rem;
            }
        }
    }
    .form{
        width: 5.9rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .title{
            // margin-bottom: .2rem;
        }
        .input_group{
            width: 100%;
            display: flex;
            gap: .24rem;
            margin-bottom: .24rem;
            &:last-child{
                margin-bottom: 0;
            }
            @media only screen and (max-width: 750px) {
                gap: .3rem;
            }
        }
        input,
        textarea,
        .btn{
            width: 0;
            flex: 1;
            height: .4rem;
            font-size: .18rem;
            border: 1px solid #666;
            padding: 0 .15rem;
            &::placeholder{
                color: #666;
            }
            @media only screen and (max-width: 750px) {
                padding: 0 .2rem;
                font-size: .26rem;
                height: .7rem;
            }
        }
        textarea{
            height: 1.8rem;
            padding: .1rem .15rem;
            @media only screen and (max-width: 750px) {
                height: 2.7rem;
                padding: .2rem;
            }
        }
        .btn{
            flex: none;
            width: .9rem;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                width: 1.2rem;
            }
        }
    }
}
</style>